<label class="container">
    <input
        [disabled]="disabled"
        type="checkbox"
        [checked]="checked"
        (change)="onChange($event.target.checked)"
    />
    <span class="checkmark"></span>
</label>